var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "register-container" }, [
    _c("h3", { staticClass: "text-center" }, [_vm._v("利用規約")]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "announce-container accept-license-container p-xs flexbox"
      },
      [
        _c("div", { staticClass: "flex-grow" }, [
          _c(
            "a",
            {
              staticStyle: { color: "#333" },
              attrs: { href: _vm.downloadUrl, target: "_blank" },
              on: { click: _vm.download }
            },
            [_vm._m(0)]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-block m-t-md",
              attrs: { type: "button" },
              on: { click: _vm.acceptLicense }
            },
            [_vm._v("\n        利用規約に同意する\n      ")]
          ),
          _vm._v(" "),
          _vm.showMessage
            ? _c("div", { staticClass: "font-bold text-danger m-t-xs" }, [
                _vm._v("※利用規約をご確認のうえ、同意してください")
              ])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-basic btn-block", attrs: { type: "button" } },
      [
        _c("i", {
          staticClass: "fa fa-download",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" 利用規約を確認する ")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7e6d7b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7e6d7b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/AcceptLicense.vue
// module id = null
// module chunks = 